import React from 'react'
import Img from 'gatsby-image'

export default ({file}) => (
    <section className="container pt-16 pb-8 px-3 mx-auto max-w-3xl">
        <div className="flex justify-center">
            <div className="flex flex-col">
                <Img
                    fluid={file.childImageSharp.fluid}
                    className="rounded-full w-32 mx-auto"
                    alt="Photo de profil"
                />

                <h1 className="mr-4 text-3xl text-gray-700 font-normal">
                    <span className="font-extrabold text-black">Hồ Văn Chương</span>
                </h1>
            </div>
        </div>

        <div className="post-content text-gray-700">
            <p>
                Chuong is a technology researcher focused on driving digital transformation for businesses. His main
                emphasis is on facilitating efficient data exchange and collaboration among engineers in the AEC
                industry (Architecture, Engineering, and Construction). He is currently devoted to exploring deep
                programming aspects within Autodesk software, promoting technology, and enhancing data exchange combined
                with effective cloud solutions for enterprises. He enjoys mountain climbing, exploratory travel, and
                connecting with friends all around the world.
            </p>

            <p>
                If you like what I write here, please buy or donate 1$(SGD) to someone in difficult situation or
                need help you meet on the road today.
            </p>
            <p>
                <strong>
                    Last words, thank you for visiting my blog, if you see it, please share and leave a comment below
                    the article!</strong>
            </p>
        </div>
    </section>
)
